module.exports = __webpack_public_path__ + "img/surveillance.22ee64b6.jpeg";